import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "41",
  height: "40",
  viewBox: "0 0 41 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.6453 26.2077H28.0756L28.8975 21.7319L29.202 20.0735L29.202 20.0735H22.6453V17.904C22.6453 17.5733 22.6585 17.2633 22.6858 16.9734C22.7253 16.5527 22.7944 16.1742 22.8954 15.8351C23.4074 14.117 24.74 13.4157 27.2085 13.4157C28.2309 13.4157 29.0538 13.4407 29.5276 13.4905V7.92984C29.5276 7.92984 29.5276 7.92981 29.5275 7.92981C29.4153 7.89864 29.2829 7.86746 29.1345 7.83677C28.0957 7.62196 26.2765 7.43102 25.1638 7.43102C18.4561 7.43102 15.3641 10.5979 15.3641 17.4303V20.0735H11.2247V26.2076H11.2248V26.2077H15.3641V39.5559C15.3641 39.5559 15.3641 39.5559 15.3641 39.5559V39.5559C6.62082 37.3867 0.139893 29.4876 0.139893 20.0735C0.139893 8.98723 9.12712 -3.8147e-06 20.2134 -3.8147e-06C31.2997 -3.8147e-06 40.2869 8.98723 40.2869 20.0735C40.2869 30.3365 32.5845 38.7995 22.6453 40V40C22.6453 40 22.6453 40 22.6453 40V26.2077Z",
      fill: "#1877F2"
    }, null, -1)
  ])))
}
export default { render: render }